import * as React from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import RebatesFilter from './Components/RebatesFilter';
import RebateListItem from './Components/RebateListItem';
import { postAprobarRebatesApi, deleteRebatesApi } from '../../api/axios';
import { fetchSellersFilter } from '../../actions/sellersActions';
import { fetchRebates, setFiltroRebates } from '../../actions/rebatesActions';
import { limpiarFiltros } from '../../actions/generalActios';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { filtroUnaSemana } from '../../utilities/fechasFiltro';
import BigSpinner  from '../General/BigSpinner';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";

const fechaFiltro = filtroUnaSemana();

class ListRebates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      onFilter: true
    }
  }

  componentDidMount() {

    let pag = this.props.filtroRebates?.numeroPagina;

    if (!this.props.emptyFiltro.rebates) {
      pag = 1;
    }

    this.setState({ currentPage: pag != null ? pag : 1 });

    if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
      this.props.fetchSellersFilter(null);
    }

    this.busquedaRebates();
  }

  busquedaRebates = () => {

    let idSeller = this.props.userType.isAdminMod ? this.props.filtroRebates.idSeller : this.props.idSeller;
    idSeller = this.props.userType.isCategory ? null : idSeller;

    let filtroRebates = this.props.filtroRebates;

    if (!this.props.emptyFiltro.rebates || filtroRebates.fechaRebateHasta === undefined) {
      filtroRebates.fechaRebateHasta = fechaFiltro.hasta;
    }

    if (!this.props.emptyFiltro.rebates || filtroRebates.fechaRebateDesde === undefined) {
      filtroRebates.fechaRebateDesde = fechaFiltro.desde;
    }

    if (!this.props.emptyFiltro.rebates || filtroRebates.idTipoEstado === undefined) {
      filtroRebates.idTipoEstado = 3;
    }

    this.props.fetchRebates({
      idSeller: idSeller,
      idTipoEstado: filtroRebates.idTipoEstado,
      skuSeller: filtroRebates.skuSeller,
      skuMarket: filtroRebates.skuMarket,
      fechaRebateDesde: filtroRebates.fechaRebateDesde,
      fechaRebateHasta: filtroRebates.fechaRebateHasta,
      numeroPagina: filtroRebates?.numeroPagina,
      IdTipoUser: this.props.tipoUsuario
    });
  }

  chargeFilterOptions = (options) => {
    this.props.setFiltroRebates(options);
  }

  setInitialPage = () => {
    this.setState({ currentPage: 1 });
  }

  handleEstadoRebate = (idRebate, idEstado) => {

    if (idEstado === 2 && this.props.userType.isSellerAdmin) {
      idEstado = 3;
    }

    let request = {
      idUsuario: this.props.idUsuario,
      idEstado: idEstado,
      idRebate: idRebate
    }

    const req = postAprobarRebatesApi(request);

    req.then(res => {
      toast.success("Estado de rebate cambiado.");
      this.busquedaRebates();
    }).catch(err => {
      (err.response.data.errores) ?
        err.response.data.errores.forEach(error => toast.error(error))
        : toast.error("No se pudo cambiar el estado rebate.");
    });
  }

  deleteRebate = (idRebate) => {

    const req = deleteRebatesApi(idRebate);

    req.then(response => {
      toast.success("Rebate eliminado");
      this.busquedaRebates();
    }).catch(err => {
      (err.response.data.errores)
      ? err.response.data.errores.forEach(error => toast.error(error))
      : toast.error("No pudo eliminarse");
    })
  }

  goToPublicacion = (idPublicacion) => {

    this.props.limpiarFiltros({ ...this.props.emptyFiltro, rebates: false })
    localStorage.setItem("pId", idPublicacion);

    let pathReturn = `/Rebates`
    this.props.history.push({
      pathname: `/Publicaciones/Editar/${this.props.idSeller}/${idPublicacion}`,
      state: pathReturn
    });
  }

  handlePageChange = (options) => {
    this.props.filtroRebates.numeroPagina = options.selected + 1;
    this.setState({ currentPage: options.selected + 1 });
    this.busquedaRebates();
  }


  render() {


    return (
      <div className="row justify-content-between algin-items-center">

        <div className="col-12 col-md-auto">
          <h3 className="text-themecolor color-rojo-megatone">Gestión de Rebates</h3>
        </div>

        <div className="col-12 col-md-auto text-end text-md-start pb-2 pb-md-0">
          <BtnToggleFilter show={this.state.onFilter} handleShow={() => this.setState({ onFilter: !this.state.onFilter })}></BtnToggleFilter>
        </div>

        <div hidden={!this.state.onFilter}>
          <RebatesFilter
            filtro={this.props.emptyFiltro.rebates === false ? this.props.filtroRebates : ""}
            setInitialPage={this.setInitialPage}
            chargeFilterOptions={this.chargeFilterOptions}
          />
        </div>

        <div hidden={!this.props.loadingRebates}>
          <BigSpinner/>
        </div>

        <div>
        {
          this.props.rebates.length === 0 || this.props.loadingRebates ? null :
            this.props.rebates.map((rebate, i) => {
              return (
                <RebateListItem
                  key={i}
                  idRebate={rebate.idRebate}
                  idPublicacion={rebate.idPublicacion}
                  descripcionSeller={rebate.razonSocial}
                  imagen={rebate.imagen[0].urlImagen}
                  titulo={rebate.titulo}
                  skuSeller={rebate.skuSeller}
                  skuMarket={rebate.skuMarket}
                  precioLista={rebate.precioInicial}
                  estadoRebate={rebate.estadoRebate}
                  fechaInicio={rebate.fechaInicio}
                  fechaVencimiento={rebate.fechaVencimiento}
                  porcentajeTotalDescuento={rebate.porcentajeTotalDescuento}
                  aCargoMegatone={rebate.aCargoMegatone}
                  porcentajeMegatone={rebate.porcentajeMegatone}
                  aCargoSeller={rebate.aCargoSeller}
                  porcentajeSeller={rebate.porcentajeSeller}
                  precioFinal={rebate.precioFinal}
                  unidades={rebate.unidades}
                  unidadesRestantes={rebate.unidadesRestantes}
                  onPublicacion={this.goToPublicacion}
                  deleteRebate={this.deleteRebate}
                  handleEstadoRebate={this.handleEstadoRebate}
                  tipoPublicacion={rebate.tipoPublicacion}
                  userType={this.props.userType}
                />
              )
            })
        }
        </div>

        <div hidden={this.props.cantidadTotal > 0 || this.props.loadingRebates}>
          <h5 className="d-flex justify-content-center m-t-40 m-b-40">
            NO SE ENCONTRARON RESULTADOS
          </h5>
        </div>

        <div className="d-flex justify-content-center">
          <ReactPaginate
            previousLabel={"Anterior"}
            nextLabel={"Siguiente"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={this.props.cantidadTotal / 10}
            marginPagesDisplayed={5}
            pageRangeDisplayed={10}
            onPageChange={this.handlePageChange}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={this.state.currentPage - 1}
          />
        </div>

      </div>
    );
  }
}


const mapStateToProps = state => ({
  rebates: state.rebates.rebates.rebates,
  loadingRebates: state.rebates.loadingRebates,
  idSeller: state.general.idSeller,
  idUsuario: state.general.userId,
  tipoUsuario: state.general.tipoUsuario,
  cantidadTotal: state.rebates.rebates.cantidadTotal,
  filtroRebates: state.rebates.filtro,
  emptyFiltro: state.general.limpiar,
  userType: state.general.userType
});

export default connect(mapStateToProps, {
  setFiltroRebates,
  fetchRebates,
  fetchSellersFilter,
  limpiarFiltros
})(ListRebates);